module.exports = __webpack_public_path__ + "static/media/investorsleftIcon.9cbd2fc5.png";